import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/inicio/LOGO_EL INDUSTRIAL.png";
import facebookIcon from "../assets/images/inicio/icono facebook.png";
import phone from "../assets/images/inicio/icono telefono.png";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { label: "Inicio", path: "/" },
    { label: "Somos", path: "/somos" },
    { label: "Servicios", path: "/servicios" },
    { label: "Galería", path: "/galeria" },
    // { label: "Catálogo", path: "/catalogo" },
    { label: "Contacto", path: "/contacto" },
  ];

  return (
    <nav className="navbar-container">
      {/* Logo */}
      <Link to="/">
        <img src={logo} alt="Logo" className="navbar-logo" loading="lazy" />
      </Link>
      {/* Hamburger Menu (mobile) */}
      <div
        onClick={() => setMenuOpen(!menuOpen)}
        className="menu-toggle"
        aria-label="Toggle menu"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setMenuOpen(!menuOpen);
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Menu Links */}
      <div className={`menu ${menuOpen ? "open" : ""}`}>
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={() => setMenuOpen(false)} // Cierra menú al hacer click en mobile
          >
            {item.label}
          </Link>
        ))}
        <div
          style={{
            width: 45,
            height: 45,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <a href="tel:+8127249484">
            <img
              src={phone}
              style={{
                width: 30.22,
                height: 30,
                left: 4.89,
                top: 5,
                position: "absolute",
                // background: "white",
              }}
              loading="lazy"
              alt="telefono"
            />
          </a>
        </div>
        <div
          style={{
            width: 45,
            height: 45,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <img
            src={facebookIcon}
            style={{
              width: 30.22,
              height: 30,
              left: 4.89,
              top: 5,
              position: "absolute",
              // background: "white",
            }}
            alt="facebook"
            loading="lazy"
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
